<template>
  <span :class="`icon si si-${name}`"></span>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/smartbox-icons.scss';
</style>
